import { render, staticRenderFns } from "./QuestionAddEditModal.vue?vue&type=template&id=b9a85084&"
import script from "./QuestionAddEditModal.vue?vue&type=script&lang=js&"
export * from "./QuestionAddEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports